module.exports = __webpack_public_path__ + "img/metz-logo-icon.63b6b8e2.png";